/**
 * useUnsavedChangesWarning — install the browser's beforeunload prompt
 * while a draft has unsaved changes.
 *
 * Used by full-route authoring surfaces (SkillEditor, PersonaEditor) where
 * navigating away by closing the tab or hitting back would lose work.
 * Sub-pane surfaces like EditWithAIView don't use this — they have their
 * own Submit/Discard chrome and the prompt would be noise.
 */

import { useEffect } from 'react';

export function useUnsavedChangesWarning(hasUnsavedChanges: boolean): void {
  useEffect(() => {
    if (!hasUnsavedChanges) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [hasUnsavedChanges]);
}
